<div mat-dialog-title
     class="title">
    <div class="subtitle">{{ formTitle | translate }}</div>
    <button mat-icon-button
            mat-dialog-close
            tabindex="-1"
            [matTooltip]="'Close' | translate"
            class="close-button hidden">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="line">
        <mat-form-field color="primary">
            <input matInput
                    #nameInput
                    [required]="true"
                    [formControl]="nameFormControl"
                    type="text"
                    maxlength="{{ NAME_MAX_LENGTH }}"
                    [placeholder]="'Team_Name' | translate">
        </mat-form-field>
    </div>
    <div class="line line-margin">
        <mat-form-field color="primary">
            <textarea matInput
                        [formControl]="teamDescriptionFormControl"
                        class="text-area-unresizable"
                        maxlength="{{ DESCRIPTION_MAX_LENGTH }}"
                        #teamDescriptionInput
                      cdkTextareaAutosize
                        placeholder="{{ 'Team_Description' | translate }}"></textarea>
            <mat-hint align="end">{{ teamDescriptionInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
        </mat-form-field>
    </div>

</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button
            mat-dialog-close
            tabindex="-1">
        {{ 'Cancel' | translate}}
    </button>
    <button mat-raised-button
            (click)="onSaveClicked()"
            color="accent">
        {{ confirmButtonTitle | translate}}
    </button>
</mat-dialog-actions>
<div class="progress-container">
    <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
</div>
